import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { addWindowListener, removeWindowListener } from '@eb/eds-utils';

import { getImageForBreakpoint } from '../utils/background';

import { HEADER_IMAGES_PROPTYPES } from '../constants/header';

import './HeaderBackground.scss';

const MainHeaderBackground = ({ imageSrc, isSeasonal }) => {
    let mainBg = null;
    let style = {};
    const [isImageLoaded, setImageLoaded] = useState(false);
    const imageWrapperClasses = classnames('header__main-bg-wrapper', {
        'header__main-bg-wrapper--empty': !isImageLoaded,
        'header__main-bg-wrapper--seasonal': isSeasonal,
    });

    if (imageSrc) {
        mainBg = (
            <img
                className={classnames('header__main-bg', 'eds-hide')}
                src={imageSrc}
                alt="consumer-header-background"
                onLoad={() => setImageLoaded(true)}
            />
        );
    }

    // Once the image is loaded it stays in browser cache,
    // this will not trigger a second request.
    if (isImageLoaded) {
        style = {
            backgroundImage: `url(${imageSrc})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        };
    }

    return (
        <>
            <div className={imageWrapperClasses} style={style}>
                {mainBg}
            </div>
        </>
    );
};

const HEADER_BACKGROUND_TYPES = {
    MainHeaderBackground,
};

export default class HeaderBackground extends Component {
    static propTypes = {
        type: PropTypes.oneOf(Object.keys(HEADER_BACKGROUND_TYPES)).isRequired,
        // TODO: check this as seems to not be in use.
        preventImageDownloading: PropTypes.bool,
        headerImages: PropTypes.shape(HEADER_IMAGES_PROPTYPES),
        isSeasonal: PropTypes.bool,
    };

    static defaultProps = {
        preventImageDownloading: false,
    };

    state = {
        hasWindow: false,
        imageSrc: '',
    };

    componentDidMount() {
        addWindowListener('resize', this.updateMediaQueryStatus);
        const { headerImages = {} } = this.props;

        this.setState({
            hasWindow: true,
            imageSrc: getImageForBreakpoint({
                windowWidth: window.innerWidth,
                imagesSet: headerImages,
            }),
        });
    }

    //TODO: Refactor to remove component will receive props
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps({ headerImages = {} }) {
        this.setState({
            imageSrc: getImageForBreakpoint({
                windowWidth: window.innerWidth,
                imagesSet: headerImages,
            }),
        });
    }

    componentWillUnmount() {
        if (this.state.hasWindow) {
            removeWindowListener('resize', this.updateMediaQueryStatus);
        }
    }

    updateMediaQueryStatus = () => {
        const { preventImageDownloading, headerImages = {} } = this.props;

        if (!preventImageDownloading && this.state.hasWindow) {
            this.setState({
                imageSrc: getImageForBreakpoint({
                    windowWidth: window.innerWidth,
                    imagesSet: headerImages,
                }),
            });
        }
    };

    render() {
        const { type, isSeasonal } = this.props;
        const { imageSrc } = this.state;
        const Background = HEADER_BACKGROUND_TYPES[type];

        return <Background imageSrc={imageSrc} isSeasonal={isSeasonal} />;
    }
}
